export const hi = {
    // MobileNo Screen
    header_title: "अखिल भारतीय आयुर्विज्ञान संस्थान, भोपाल",
    header_subtitle: "ओरो कैंसर वॉच",
    header_small: "द्वारा प्रायोजित",
    header_mpct: "मध्य प्रदेश विज्ञान और प्रौद्योगिकी परिषद",
    get_started: "कृपया मोबाइल नंबर दर्ज करें",
    enter_phone: "आपके द्वारा दर्ज किए गए नंबर पर ओटीपी भेजा जाएगा।",
    mobile_label: "मोब नं.",
    continue_btn: "जारी रखें",
    welcome_title: "डॉक्टर ऐप में आपका स्वागत है",
    welcome_text: "लोरेम इप्सम डोलर सिट अमेट, कंसेक्टेटुर एडिपिसिंग एलीट।", // Placeholder text transliterated/translated
    language_label: "भाषा",

    // Chatbox
    chatbox_title: "चैटबॉक्स",
    back_btn: "वापस",
    reset_btn: "रीसेट",
    history_title: "इतिहास वार्तालाप",
    history_text: "लोरेम इप्सम डमी टेक्स्ट है...",

    // Questions
    b_Continue:"जारी रखें",
    q_hii:"नमस्कार",
    q_namaskar:"निदान प्रक्रिया शुरू करने के लिए कृपया ‘जारी रखें’ पर क्लिक करें।",
    q_smoke: "क्या आप धूम्रपान करते हैं?",
    q_smoke_type: "आप किस प्रकार का धूम्रपान करते हैं?",
    opt_cigarette: "सिगरेट",
    opt_bidi: "बीड़ी",
    opt_cigar: "सिगार",
    opt_hookah: "हुक्का",
    q_smoke_duration: "धूम्रपान की अवधि",
    q_smoke_freq: "धूम्रपान की आवृत्ति",
    opt_occ: "कभी-कभी (दिन में एक बार से कम)",
    opt_1_5: "1-5 बार/दिन",
    opt_6_10: "6-10 बार/दिन",
    opt_10_plus: "10 से अधिक बार/दिन",
     opt_smoke_dur1:"1 वर्ष से कम",
    opt_smoke_dur2:"1 से 5 वर्ष",
    opt_smoke_dur3:"5 वर्ष से अधिक",
    q_chew: "क्या आप सुपारी / पान मसाला / गुटखा चबाते हैं?",
    q_chew_duration: "अवधि",
    q_chew_freq: "चबाने की आवृत्ति",

    q_alcohol: "क्या आप शराब का सेवन करते हैं?",
    q_alcohol_duration: "अवधि",
    q_alcohol_freq: "आवृत्ति",

    q_symptoms: "आप किन लक्षणों का अनुभव कर रहे हैं (जो लागू हों उन्हें चुनें)",

    q_location: "मुंह की समस्या का स्थान (जो लागू हों उन्हें चुनें)",
    q_side: "शामिल पक्ष",
    opt_right: "दायां",
    opt_left: "बायां",
    opt_both: "दोनों",

    q_upload_photo: "समस्या दिखाने वाले मुंह के क्षेत्र की स्पष्ट तस्वीर अपलोड करें",
    q_result: "परिणाम देखने के लिए कृपया नीचे दिए गए बटन पर क्लिक करें",

    // Disclaimer
    terms_title: "नियम और शर्तें",
    terms_text: "ओरो कैंसर वॉच स्क्रीनिंग टूल को ओरल पोटेंशियली मैलिग्नेंट डिसऑर्डर्स (OPMD) से जुड़े जोखिम कारकों की पहचान करने के लिए डिज़ाइन किया गया है और यह एक निश्चित नैदानिक उपकरण नहीं है। सभी उत्पन्न परिणाम सांकेतिक हैं; 'कम जोखिम' परिणाम बीमारी की उपस्थिति को खारिज नहीं करता है, और 'उच्च जोखिम' परिणाम कैंसर की पुष्टि नहीं करता है। उपयोगकर्ताओं को दंत चिकित्सक या ऑन्कोलॉजिस्ट से परामर्श करने की सख्त सलाह दी जाती है।",
    terms_text1: "इस एप्लिकेशन द्वारा प्रदान की गई स्क्रीनिंग, फोटोग्राफिक साक्ष्य और उपयोगकर्ता द्वारा रिपोर्ट की गई आदतों पर आधारित एक गैर-आक्रामक, प्रारंभिक जोखिम मूल्यांकन है। यह मौखिक म्यूकोसल असामान्यताओं की पहचान करने के लिए है जो मुंह के कैंसर के बढ़ते जोखिम से जुड़े हो सकते हैं। उपयोगकर्ताओं को यह समझना चाहिए कि यह डिजिटल स्क्रीनिंग बायोप्सी या निश्चित चिकित्सा निदान का गठन नहीं करती है। 'कम जोखिम' परिणाम स्वास्थ्य की गारंटी नहीं है, और 'उच्च जोखिम' परिणाम कैंसर की पुष्टि नहीं है।",
    terms_text2: "इस एप्लिकेशन का उपयोग करके, आप हमारे द्वारा आपके व्यक्तिगत और संवेदनशील स्वास्थ्य डेटा, जिसमें मौखिक घावों की तस्वीरें शामिल हैं, को केवल मौखिक स्वास्थ्य स्क्रीनिंग और जोखिम मूल्यांकन के उद्देश्य से एकत्र करने और संसाधित करने के लिए अपनी स्पष्ट और सकारात्मक सहमति प्रदान करते हैं। इस डेटा का उपयोग हमारी स्क्रीनिंग एल्गोरिथम को बेहतर बनाने के लिए भी किया जा सकता है ताकि यह सुनिश्चित हो सके कि ऐप समुदाय के लिए एक विश्वसनीय, साक्ष्य-आधारित डिजिटल संसाधन बना रहे। आपके पास किसी भी समय अपनी सहमति वापस लेने का अधिकार है; हालांकि, कृपया समझें कि सहमति वापस लेने से हम आपको स्क्रीनिंग परिणाम या आगे का मूल्यांकन प्रदान करने में असमर्थ होंगे। डेटा संग्रह और उपयोग का उद्देश्य सटीक, रोगी-अनुकूल जानकारी के माध्यम से शीघ्र पहचान और सूचित निर्णय लेने को बढ़ावा देना है।",
    terms_text3: "एक उपयोगकर्ता के रूप में इस एप्लिकेशन का उपयोग करते हुए, आप अपने चिकित्सा इतिहास, तंबाकू या सुपारी के उपयोग और अन्य स्वास्थ्य आदतों के संबंध में सटीक और पूरी जानकारी प्रदान करने के लिए जिम्मेदार हैं, ताकि एक मान्य जोखिम मूल्यांकन सुनिश्चित हो सके। स्क्रीनिंग टूल का उपयोग करते समय, आपको यह सुनिश्चित करना चाहिए कि मौखिक गुहा की कोई भी तस्वीर स्पष्ट, अच्छी तरह से रोशनी वाली हो और चिंता के क्षेत्र को निर्देशानुसार कैप्चर करे, क्योंकि खराब गुणवत्ता वाले डेटा के कारण गलत परिणाम हो सकते हैं।",
    terms_text4: "इस एप्लिकेशन की सामग्री, सुविधाओं और कार्यक्षमता, जिसमें स्क्रीनिंग एल्गोरिदम, जोखिम मूल्यांकन तर्क, सॉफ्टवेयर कोड, उपयोगकर्ता इंटरफ़ेस डिज़ाइन और शैक्षिक सामग्री शामिल हैं, लेकिन इन्हीं तक सीमित नहीं हैं, डेवलपर्स की बौद्धिक संपदा हैं। यह एप्लिकेशन सामुदायिक स्वास्थ्य जागरूकता के लिए एक साक्ष्य-आधारित डिजिटल संसाधन के रूप में प्रदान किया गया है, और उपयोगकर्ताओं को केवल व्यक्तिगत, गैर-वाणिज्यिक उपयोग के लिए एक सीमित, गैर-हस्तांतरणीय लाइसेंस प्रदान किया जाता है। डेवलपर्स की पूर्व लिखित सहमति के बिना एप्लिकेशन की तकनीक या मालिकाना स्क्रीनिंग विधियों के किसी भी हिस्से को कॉपी, संशोधित, रिवर्स-इंजीनियर या वितरित करना सख्त वर्जित है।",
    terms_text5: "डेवलपर्स इस स्क्रीनिंग टूल के उपयोग से होने वाले किसी भी स्वास्थ्य परिणाम या क्षति के लिए उत्तरदायी नहीं हैं। यह ऐप प्रारंभिक पहचान के लिए एक 'ट्राइएज' संसाधन है, न कि नैदानिक निदान; हम मूल्यांकन की अशुद्धियों या तकनीकी त्रुटियों के लिए जिम्मेदार नहीं हैं। इस एप्लिकेशन का उपयोग करके, आप स्वीकार करते हैं कि अंतिम नैदानिक जिम्मेदारी एक योग्य स्वास्थ्य सेवा प्रदाता की होती है, जो शारीरिक परीक्षा के बाद ही अपनी जिम्मेदारी लेता है।",
    terms_text6: "शिकायत अधिकारी: भारतीय कानून (आईटी नियम 2011) के तहत, आपको एक शिकायत अधिकारी का नाम और संपर्क विवरण प्रदान करना होगा, जिनसे उपयोगकर्ता डेटा या सेवा संबंधी मुद्दों के संबंध में संपर्क कर सकते हैं।",
    terms_text7: "यदि आपको अपनी डेटा गोपनीयता या प्रदान की गई सेवाओं के संबंध में कोई चिंता है, तो कृपया हमारे शिकायत अधिकारी, [नाम], से [ईमेल एड्रेस] पर संपर्क करें। हम आपकी शिकायत को 48 घंटों के भीतर स्वीकार करने और 30 दिनों के भीतर इसे हल करने के लिए प्रतिबद्ध हैं।",
    agree_terms: "मैं ऊपर दिए गए नियमों और शर्तों से सहमत हूं",
    start_chat: "आगे",
    // pateints form
    p_title:"व्यक्तिगत विवरण",
    p_mob:"मोबाइल नंबर",
    p_name:"पूरा नाम",
    p_dob:"जन्म तिथि",
    p_gender:"लिंग",
    p_male:"पुरुष",
    p_female:"महिला",
    p_other:"अन्य",
    p_address:"पता",
    // About
    about_title: "हमारे बारे में",
    a_title1: "परिचय",
    a_para1: "यह मोबाइल एप्लिकेशन एक अभिनव डिजिटल स्वास्थ्य पहल है, जिसे All India Institute of Medical Sciences Bhopal के डॉक्टरों और शोधकर्ताओं द्वारा विकसित किया गया है। इसका उद्देश्य ओरल पोटेंशियली मैलिग्नेंट डिसऑर्डर्स (OPMDs) और मुख कैंसर (Oral Cancer)की प्रारंभिक पहचान में सहायता प्रदान करना है।",
    list1: " OPMDs ऐसे मौखिक रोग हैं जिनमें समय पर पहचान और उपचार न होने पर कैंसर में परिवर्तित होने की संभावना अधिक रहती है। भारत जैसे देशों में, जहाँ तंबाकू और उससे संबंधित आदतें व्यापक रूप से प्रचलित हैं, वहाँ मुख कैंसर एक प्रमुख सार्वजनिक स्वास्थ्य समस्या बना हुआ है। इन स्थितियों की प्रारंभिक पहचान उपचार के परिणामों को बेहतर बनाने और मृत्यु दर को कम करने में महत्वपूर्ण भूमिका निभाती है।",
    list2: "यह एप्लिकेशन उन्नत चिकित्सीय स्क्रीनिंग और आम जनता के बीच मौजूद अंतर को कम करने के उद्देश्य से विकसित किया गया है। स्मार्टफोन के माध्यम से यह एक सरल, सुलभ और तकनीक-आधारित समाधान प्रदान करता है।",
    a_title2: "एप्लिकेशन का उद्देश्य",
    a_para3:"इस एप्लिकेशन का मुख्य उद्देश्य मोबाइल तकनीक की सहायता से ओरल पोटेंशियली मैलिग्नेंट डिसऑर्डर्स (OPMDs) की प्रारंभिक स्क्रीनिंग और पहचान में सहायता करना है।",
    a_subtitle2:"यह एप्लिकेशन निम्नलिखित उद्देश्यों के लिए विकसित किया गया है:",
    list3:"मुख कैंसर और प्रीकैंसरस स्थितियों की प्रारंभिक पहचान को बढ़ावा देना",
    list4:"स्वास्थ्यकर्मियों और डॉक्टरों को रोगियों की शीघ्र स्क्रीनिंग में सहायता प्रदान करना",
    list5:"त्वरित जोखिम मूल्यांकन और प्रारंभिक मार्गदर्शन उपलब्ध कराना",
    list6:"मौखिक स्वास्थ्य तथा हानिकारक आदतों के प्रति जन-जागरूकता बढ़ाना",
    list7:"मुख कैंसर की रोकथाम के लिए अनुसंधान और डेटा संग्रह को समर्थन देना",
    listp8:"इस मंच के माध्यम से व्यक्ति आसानी से स्क्रीनिंग करवा सकते हैं और आवश्यकता पड़ने पर आगे की चिकित्सीय जांच के लिए रेफर किए जा सकते हैं।",
    a_title3: "एप्लिकेशन कैसे कार्य करता है:",
    a_para4:"यह मोबाइल एप्लिकेशन उपयोगकर्ता के अनुकूल इंटरफेस और बुद्धिमान एल्गोरिदम का उपयोग करके मुख से संबंधित रोगों के लक्षणों की पहचान में सहायता करता है।",
   a_subtitle3:"मुख्य चरण इस प्रकार हैं:",
    para4_list1:"उपयोगकर्ता पंजीकरण",
    para4_listp1:"उपयोगकर्ता या स्वास्थ्यकर्मी आयु, लिंग, चिकित्सा इतिहास और जीवनशैली संबंधी आदतों (जैसे तंबाकू सेवन, शराब सेवन आदि) की मूलभूत जानकारी दर्ज करते हैं।",
     para4_list2:"मौखिक परीक्षण की जानकारी",
    para4_listp2:"उपयोगकर्ता या स्वास्थ्यकर्मी मौखिक गुहा (oral cavity) से संबंधित तस्वीरें अपलोड कर सकते हैं या क्लिनिकल विवरण दर्ज कर सकते हैं।",
     para4_list3:"स्वचालित विश्लेषण",
     para4_listp3:"सिस्टम प्रदान की गई जानकारी का विश्लेषण कर निम्नलिखित संभावित संकेतों की पहचान करता है:",
     para4_sublist3:"ओरल पोटेंशियली मैलिग्नेंट डिसऑर्डर्स (OPMDs)",
      para4_sublist31:"मुख कैंसर के जोखिम संकेत",
       para4_sublist32:"मुँह खोलने में कमी (restricted mouth opening) तथा अन्य मौखिक स्वास्थ्य स्थितियाँ",
     para4_list4:"त्वरित परिणाम और मार्गदर्शन",
     para4_listp4:"एप्लिकेशन कुछ ही मिनटों में प्रारंभिक स्क्रीनिंग परिणाम प्रदान करता है और यह सुझाव देता है कि उपयोगकर्ता को आगे की जांच के लिए किसी चिकित्सक से परामर्श लेना चाहिए या नहीं।",
    a_title4: "यह एप्लिकेशन जनता के लिए कैसे उपयोगी है",
    a_para5: "यह एप्लिकेशन समुदाय को कई महत्वपूर्ण लाभ प्रदान करता है।",
      para5_list1:"मुख कैंसर की प्रारंभिक पहचान",
    para5_listp1:"लक्षणों की प्रारंभिक अवस्था में पहचान होने से व्यक्ति समय पर चिकित्सा सहायता प्राप्त कर सकते हैं और रोग की प्रगति को रोका जा सकता है।",
    para5_list2:"स्क्रीनिंग तक आसान पहुँच",
    para5_listp2:"ग्रामीण और दूरस्थ क्षेत्रों में विशेष स्वास्थ्य सेवाओं तक पहुँच सीमित होती है। स्मार्टफोन आधारित यह स्क्रीनिंग टूल किसी भी व्यक्ति को प्रारंभिक जांच करने की सुविधा प्रदान करता है।",
    para5_list3:"जागरूकता और शिक्षा",
    para5_listp3:"यह एप्लिकेशन उपयोगकर्ताओं को निम्नलिखित विषयों के बारे में जानकारी प्रदान करता है:",
    para5_listp31:"तंबाकू और सुपारी के सेवन के जोखिम",
    para5_listp32:"मुख रोगों के चेतावनी संकेत",
    para5_listp33:"मौखिक स्वास्थ्य की रोकथाम संबंधी उपाय",
    para5_list4:"त्वरित चिकित्सीय रेफरल",
    para5_listp4:"यदि किसी संदिग्ध लक्षण का पता चलता है, तो एप्लिकेशन दंत चिकित्सक या विशेषज्ञ से परामर्श की सलाह देता है, जिससे समय पर निदान और उपचार संभव हो सके।",
    para5_list5:"सार्वजनिक स्वास्थ्य कार्यक्रमों को समर्थन",
    para5_listp5:"एप्लिकेशन के माध्यम से प्राप्त डेटा स्वास्थ्य अधिकारियों को रोग के पैटर्न को समझने और बेहतर मुख कैंसर रोकथाम कार्यक्रम तैयार करने में सहायता कर सकता है।",
      a_title6:"अनुसंधान एवं विकास",
    a_para6:"इस एप्लिकेशन का विकास Madhya Pradesh Council of Science and Technology द्वारा समर्थित एक शोध पहल का हिस्सा है, जिसका उद्देश्य मुख कैंसर की प्रारंभिक पहचान के लिए नवीन तकनीकी उपकरण विकसित करना है।",
    a_para61:"यह परियोजना All India Institute of Medical Sciences Bhopal के बहु-विषयक विशेषज्ञों की टीम द्वारा संचालित की जा रही है, जिसमें ओरल सर्जन, ऑन्कोलॉजिस्ट, पैथोलॉजिस्ट और सार्वजनिक स्वास्थ्य विशेषज्ञ शामिल हैं।",
     a_title7:"दृष्टि (Vision)",
    a_para7:"हमारी दृष्टि एक ऐसा तकनीक-सक्षम स्वास्थ्य तंत्र विकसित करना है, जिसमें प्रारंभिक पहचान, जागरूकता और निवारक देखभाल के माध्यम से मुख कैंसर के बोझ को कम किया जा सके और सामुदायिक स्वास्थ्य में सुधार किया जा सके।",
    a_title8:"मिशन (Mission)",
    para_8_list1:"मुख कैंसर स्क्रीनिंग को सुलभ, किफायती और व्यापक बनाना",
    para_8_list2:"स्वास्थ्यकर्मियों को डिजिटल निदान उपकरणों से सशक्त बनाना",
    para_8_list3:"निवारक स्वास्थ्य सेवाओं और जागरूकता को बढ़ावा देना",
    para_8_list4:"अनुसंधान-आधारित सार्वजनिक स्वास्थ्य समाधानों में योगदान देना",
    para_9:"परियोजना से जुड़े अन्वेषक (Investigators)",
    para_list91:"Dr. Anshul Rai",
    para_list911:"ओरल एवं मैक्सिलोफेशियल सर्जरी विभाग All India Institute of Medical Sciences Bhopal साकेत नगर, भोपाल, मध्य प्रदेश – 462020", 
    para_list92:"Dr. Saikat Das",
    para_list922:"रेडिएशन ऑन्कोलॉजी विभाग All India Institute of Medical Sciences Bhopal",
    para_list93:"Abhinav Singh",
    para_list933:"प्रोफेसर All India Institute of Medical Sciences Bhopal",
    para_list94:"Dr. Deepti Joshi ",
    para_list944:"पैथोलॉजी विभाग All India Institute of Medical Sciences Bhopal",
    para_list95:"Dr. Ankur Joshi",
    para_list955:"सहायक प्रोफेसर, कम्युनिटी एवं फैमिली मेडिसिन विभाग All India Institute of Medical Sciences Bhopal ",
    // opt button

    verify_otp_btn: "ओटीपी सत्यापित करें",
    otp_side_title: "ओटीपी",

       // Privacy
    privacy_title: "गोपनीयता नीति",
    privacy_text: "This Privacy Policy explains how [App Name]  collects, uses, stores, and protects information obtained from users during screening for Oral Potentially Malignant Disorders (OPMDs) and Oral Cancer. The App is developed for screening, awareness, early detection, and research purposes and does not replace professional medical diagnosis or treatment.",

    // Result
    report_title: "रिपोर्ट",
    report_text: "लोरेम इप्सम के कई रूप उपलब्ध हैं...",
    result_title: "ओरल कैंसर स्क्रीनिंग: प्रोविजनल रिपोर्ट",

    // Chatsms UI
    btn_submit: "जमा करें",
    btn_yes: "हां",
    btn_no: "नहीं",
    btn_check_results: "परिणाम देखें",
    msg_file_selected: "फ़ाइल चुनी गई",
    msg_choose_file: "फ़ाइल चुनें",
    msg_image_selected: "छवि चुनी गई",
    msg_choose_image: "छवि चुनें",
    msg_add_image: "छवि जोड़ें",

    // Symptoms
    sym_none:"कोई चयन नहीं",
    sym_burning: "मुंह में जलन, आराम करते समय / तीखा खाना खाते समय",
    sym_pain: "मुंह में दर्द या खराश",
    sym_ulcers: "मुंह के छाले जो 14 दिनों से अधिक समय तक रहते हैं",
    sym_white: "मुंह में सफेद रंग का बदलाव",
    sym_red: "मुंह में लाल रंग का बदलाव",
    sym_mixed: "मुंह में लाल और सफेद रंग का मिश्रित बदलाव",
    sym_thick: "मुंह में गाढ़ा या कठोर क्षेत्र",
    sym_open_diff: "मुंह खोलने में कठिनाई",
    sym_chew_diff: "खाना चबाने में कठिनाई",
    sym_swallow_diff: "खाना निगलने में कठिनाई",
    sym_dec_open: "पहले की तुलना में मुंह कम खुलना",
    sym_stiff: "मौखिक गुहा में जकड़न या कठोरता",
    sym_dry: "मुंह में सूखापन",
    sym_taste: "स्वाद संवेदना में बदलाव",
    sym_bleed: "छाले से खून बहना",
    sym_loose: "ढीला दांत",
    sym_irritation: "दांत का तेज किनारा जिससे जलन हो",

    // Location Options
    opt_inside_cheek: "गाल के अंदर",
    opt_Center_tongue: "जीभ का मध्य भाग",
    opt_Front_tongue: "जीभ का आगे का भाग",
    opt_Side_tongue: "जीभ का किनारा",
    opt_below_tongue: "जीभ के नीचे",
    opt_Lower_gums: "निचला मसूड़ा",
    opt_Upper_gums: "ऊपरी मसूड़ा",
    opt_backside_gums: "ऊपरी और निचले मसूड़ों का अंदरूनी हिस्सा",
    opt_roof_mouth: "मुंह की छत (तालु)",
    opt_lips: "होंठ",
    opt_lower_lips:"निचले होंठ का अंदरूनी हिस्सा",
    opt_upper_lips: "ऊपरी होंठ का अंदरूनी हिस्सा",
  //  Awerness
  aw_title:"जागरूकता",
  aw_t_one:"तंबाकू से होने वाले मुंह के नुकसान के शुरुआती लक्षण",
  aw_sb_one:"आपके मुंह के अंदर एक छुपा हुआ खतरा",
  aw_p_one:"तंबाकू के पाउच को मुंह में रखने से रासायनिक जलन, दांतों में सड़न और मसूड़ों को स्थायी नुकसान हो सकता है। लंबे समय तक उपयोग करने से प्रीकैंसरस घाव (कैंसर से पहले की अवस्था) और मुख कैंसर होने का खतरा बढ़ जाता है। नियमित रूप से दांतों की जांच करवाना और तंबाकू का सेवन छोड़ना, मुंह के स्वास्थ्य के लिए बहुत आवश्यक है। सफेद धब्बे, छाले, मसूड़ों में चोट और दांतों को नुकसान—ये सभी तंबाकू पाउच के दुरुपयोग के शुरुआती संकेत हैं। समय पर पहचान और तुरंत तंबाकू छोड़ने से गंभीर जटिलताओं, जैसे मुख कैंसर, से बचा जा सकता है।",

 aw_t_two: "तंबाकू से संबंधित मौखिक घाव",
 aw_sb_two: "शुरुआती चेतावनी संकेतों को कभी नजरअंदाज न करें",
 aw_p_two: "यह चित्र मुंह के अंदर ऊतकों में होने वाले असामान्य बदलावों को दर्शाता है, जो आमतौर पर लंबे समय तक तंबाकू के उपयोग से जुड़े होते हैं। ऐसे घाव शुरुआत में बिना दर्द के हो सकते हैं, लेकिन यदि उपचार न किया जाए तो यह गंभीर मौखिक रोगों में बदल सकते हैं। समय पर जांच, डॉक्टर की सलाह पर बायोप्सी, और तुरंत तंबाकू छोड़ना मुंह और संपूर्ण स्वास्थ्य के लिए अत्यंत आवश्यक है।",

 aw_t_three: "मुंह के ऊतकों में असामान्य बदलाव पाए गए",
 aw_sb_three: "शुरुआती संकेतों को कभी नजरअंदाज न करें",
 aw_p_three: "यह चित्र दंत जांच के दौरान मुंह के अंदर ऊतकों में चोट और सूजन को दर्शाता है। ऐसे बदलाव तंबाकू के उपयोग, लगातार जलन, नुकीले दांतों या खराब मौखिक स्वच्छता के कारण हो सकते हैं। कोई भी ऐसा घाव जो ठीक न हो, लालिमा या खून आने वाली जगह को तुरंत दंत विशेषज्ञ द्वारा जांच करवाना चाहिए।",
    // Footer
    footer_home: "होम",
    footer_about: "हमारे बारे में",
    footer_more: "अधिक",
};
